import type { DetailedHTMLProps, HTMLAttributes, ReactNode } from "react";

import { clsx, Text } from "@alpacahq/ui/old";

export interface CardProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  title?: string;
  tools?: ReactNode;
  padding?: string;
}

export const Card = ({
  title,
  tools,
  children,
  className,
  ...more
}: CardProps) => {
  return (
    <div
      className={clsx(
        "flex flex-col gap-6 rounded-lg border border-gray-200 bg-white p-6",
        className,
      )}
      {...more}
    >
      {(title !== undefined || tools !== undefined) && (
        <div className="flex flex-wrap items-start justify-between gap-2">
          {title && <Text className="font-medium text-base">{title}</Text>}
          {tools}
        </div>
      )}

      {children}
    </div>
  );
};

export default Card;
